import { render, staticRenderFns } from "./CustomContribsValue.vue?vue&type=template&id=4cb95394&"
import script from "./CustomContribsValue.vue?vue&type=script&lang=js&"
export * from "./CustomContribsValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports